
/**
 * @param kickoutCallback - callback function that's triggered when the user is exited
 */
function Inactivity(kickoutCallback) {

    var idleTime = 0, // tracker
        timeLimit = 60000 * 10, // 10 mins
        checkEvery = 60000, // 1 minute
        intervalId = null,
        timeoutId = null,

        timeout, resetTimeout, debugLog, timedOutLogic,

        webWorkerMode,
        worker,
        previousTitle;

    debugLog = function (logMessage) {
        window.console.debug('Inactivity: ' + logMessage);
    };

    timedOutLogic = function() {
        var baseUrl = $('body').data('base-url');

        debugLog('timedOutLogic()');

        if (kickoutCallback !== undefined && typeof kickoutCallback === 'function') {
            kickoutCallback();
        }

        $.post(
            baseUrl + '/set-flash',
            {
                type: 'error',
                message: 'You have been logged out of the VM due to a period of inactivity.'
            },
            function () {
                window.location = baseUrl;
            }
        );
    };

    showModal = function () {
        $('#expiry-modal').modal('show');
        document.title = 'Inactivity detected!';
    };

    timeout = function () {
        if (webWorkerMode) {
            debugLog('timeout() (web worker mode)');
            worker.postMessage('timeout');
        } else {
            debugLog('timeout() (standard mode)');

            return setInterval(function () {
                idleTime = idleTime + checkEvery;

                if (idleTime >= timeLimit) {

                    debugLog('Idle. Idle time: ' + idleTime);

                    // stop this interval
                    clearInterval(intervalId);

                    // load the modal
                    showModal();

                    // set the timer for another minute
                    timeoutId = setTimeout(timedOutLogic, checkEvery);

                    debugLog('Created timeout: ' + timeoutId);
                }
            }, checkEvery);
        }
    };

    resetTimeout = function () {
        if (webWorkerMode) {
            worker.postMessage('resetTimeout');
        } else {
            idleTime = 0;
            clearTimeout(timeoutId);
        }

        document.title = previousTitle;
    };

    this.init = function () {
        webWorkerMode = (window.Worker) ? true : false;
        previousTitle = document.title;

        if (webWorkerMode) {
            var baseUrl = $('body').data('base-url');

            debugLog('Web worker mode');

            worker = new Worker(baseUrl + '/js/inactivity-worker.js');

            worker.onmessage = function (e) {
                switch (e.data) {
                    case 'showModal':
                        debugLog('showing modal');
                        showModal();
                    break;
                    case 'timedOut':
                        debugLog('timed out');
                        timedOutLogic();
                    break;
                    default:
                        debugLog(e.data);
                }
            };
        }

        // Increment the idle time counter every minute.
        intervalId = timeout();

        debugLog('Initialised. Interval ID: ' + intervalId);

        // Zero the idle timer on user interaction
        $('#noVNC_canvas').on('mousemove keypress click dblclick', function() {
            debugLog('captured an event');
            resetTimeout();
        });

        $('#user-active').click(function() {
            resetTimeout();
            intervalId = timeout();
        });
    };

    this.destroy = function () {
        if (webWorkerMode) {
            worker.postMessage('destroy');
            worker.terminate();
        } else {
            debugLog('Destory interval: ' + intervalId + ' timeout: ' + timeoutId);

            clearInterval(intervalId);
            clearTimeout(timeoutId);
        }
    };

};
